// extracted by mini-css-extract-plugin
export default {"section":"RelatedCategories_section__0tGPK","inner":"RelatedCategories_inner__Rsd8z","title":"RelatedCategories_title__rJeCp","grid":"RelatedCategories_grid__bXa3a"};